import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import confetti from 'canvas-confetti';
import { Helmet } from 'react-helmet';
import './PaymentSuccessPage.css';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.state || location.state.from !== 'checkout') {
      navigate('/', { replace: true });
      return;
    }

    confetti({
      particleCount: 150,
      spread: 100,
      origin: { y: 0.6 },
    });

    const timer = setTimeout(() => {
      navigate('/enrolledCourses');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, location]);

  return (
    <div className="success-wrapper">
      <Helmet>
        <title>Enrollment Successful | SkillzVerse</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="success-card">
        <div className="success-badge">
          <span className="success-check">✔</span>
        </div>
        <h1 className="success-heading">You're Enrolled!</h1>
        <p className="success-description">
          Welcome to <strong>SkillzVerse</strong>! Your enrollment was successful.<br />
          We’re preparing your learning dashboard...
        </p>
        <div className="success-progress-bar">
          <div className="success-progress"></div>
        </div>
        <p className="success-redirect">Redirecting to your courses...</p>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
